export default __webpack_public_path__ + "static/media/bancoArtistas.fc7458a6.jpeg";